var map = {
	"./en-us.json": [
		"e3b5",
		"chunk-2d2255f7"
	],
	"./my-mm.json": [
		"2546",
		"chunk-2d0b28fb"
	],
	"./th-th.json": [
		"2c2c",
		"chunk-2d0bd598"
	],
	"./zh-cn.json": [
		"2c61",
		"chunk-2d0bd5e2"
	],
	"./zh-tw.json": [
		"cb6e",
		"chunk-2d221884"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "39c3";
module.exports = webpackAsyncContext;